import React from "react";
import { CLUB_BADGES } from "../lib/clubBadges";

const CLUB_COLORS = {
  dynamos: "#1e63c9", highlanders: "#111", "caps-united": "#0a8f3c", ngezi: "#5b3f16",
  "chicken-inn": "#c0392b", scottland: "#0B3D2E", hardrock: "#333", herentals: "#c0392b",
  mwos: "#0b6", "simba-bhora": "#1b5e20", platinum: "#607d8b", "bulawayo-chiefs": "#e67e22",
  kariba: "#0288d1", hunters: "#455a64", agama: "#8e24aa", telone: "#1565c0",
  "manica-diamonds": "#00838f", "triangle-united": "#d32f2f",
};

export function Crest({ slug, name, size = 40, url }) {
  const src = url || CLUB_BADGES[slug];
  if (src) return (
    <div className="bg-white rounded-sm p-0.5 flex items-center justify-center shrink-0 border border-pslborder/60" style={{ width: size, height: size }}>
      <img src={src} alt={`${name || slug} badge`} className="max-w-full max-h-full object-contain" />
    </div>
  );
  const color = CLUB_COLORS[slug] || "#E40119";
  const initials = (name || "?").split(" ").map((w) => w[0]).join("").slice(0, 3).toUpperCase();
  return (
    <div className="rounded-sm flex items-center justify-center font-head font-bold text-white shrink-0"
      style={{ width: size, height: size, background: color, fontSize: size * 0.32 }}
      data-testid={`crest-${slug}`}>
      {initials}
    </div>
  );
}

export function Zig({ value, className = "" }) {
  return <span className={`tabular ${className}`}>ZiG {Number(value).toFixed(1)}m</span>;
}

export function SectionTitle({ children, kicker, testid }) {
  return (
    <div className="mb-5" data-testid={testid}>
      {kicker && <div className="text-gold text-xs font-bold uppercase tracking-[0.2em] mb-1">{kicker}</div>}
      <h2 className="font-head font-black text-2xl md:text-3xl text-green tracking-tight">{children}</h2>
    </div>
  );
}

export function Pill({ children, tone = "green" }) {
  const tones = {
    green: "bg-green text-cream", gold: "bg-gold text-ink", live: "bg-live text-white animate-pulse",
    muted: "bg-cream border border-pslborder text-ink", confirmed: "bg-green text-cream",
    unconfirmed: "bg-amber-100 text-amber-800 border border-amber-300",
  };
  return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[11px] font-bold uppercase tracking-wider ${tones[tone] || tones.green}`}>{children}</span>;
}

export function Loading({ label = "Loading" }) {
  return <div className="py-20 text-center text-ink/50 font-head animate-pulse" data-testid="loading">{label}…</div>;
}

export function Card({ children, className = "", ...rest }) {
  return <div className={`bg-white border border-pslborder rounded-sm hover:shadow-md transition-shadow ${className}`} {...rest}>{children}</div>;
}
